import apiService from "../common/commonApi";

export const totalRecordByDate = {};
export const totalRecordByDate2 = {};
export const totalRecordByProject = {};
export const projectEmployeeSort = {};
export const departmentAndEmployee = {};
export const departmentAndEmployeeExport = {};

totalRecordByDate.list = async (param) => {    
    return apiService.Get('totalrecordbydate-list', param);
}

totalRecordByDate2.list = async (param) => {    
    return apiService.Get('totalrecordbydate-list2', param);
}

totalRecordByProject.list = async (param) => {    
    return apiService.Get('totalrecordbyproject-list', param);
}

projectEmployeeSort.list = async (param) => {    
    return apiService.Get('projectemployeesort', param);
}

departmentAndEmployee.list = async (param) => {
    return apiService.Get('getDataDepartmentAndEmployee', param);
}

departmentAndEmployeeExport.list = async (param) => {
    return apiService.Get('getDataDepartmentAndEmployee', param);
}
